import { useEffect, useState } from "react";
import { fetchMe, redirectToLogin, type Me } from "@/api";

type MeState = { status: "loading" } | { status: "signed-out" } | { status: "signed-in"; me: Me };

/**
 * Identifies the current user once on mount. A full-page IdP redirect on a
 * signed-out session doesn't fit a client-side route guard, so this stays a
 * plain effect (matching the old bootstrap()) rather than a router loader.
 */
export function useMe(): MeState {
  const [state, setState] = useState<MeState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    fetchMe()
      .then((me) => {
        if (cancelled) return;
        setState(me ? { status: "signed-in", me } : { status: "signed-out" });
      })
      .catch(() => {
        if (!cancelled) setState({ status: "signed-out" });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}

export function goToLogin(): void {
  redirectToLogin();
}
